import { mfa } from '../HttpRequests/auth';

export default ({ otp }) => async (dispatch) => {

  try {

    // set the MFA
    const data = { otp };

    const mfaResponse = await mfa({ data });

    // save token
    const { url } = mfaResponse.data;

    console.log(mfaResponse.data);
//alert('test');
    window.location = url

  } catch (error) {

    throw error;

  }

}
